import { Spinner } from '../../assets/icon/svg';

interface Props {
    title?: string;
    description?: string;
    height?: string;
}

export default function TableError({
    title = 'Unable to load records',
    description = 'Something went wrong while retrieving the records.',
    height = 'min-h-[320px]',
}: Props) {
    return (
        <tr>
            <td className="p-0" colSpan={999}>
                <div className={`flex w-full ${height} items-center justify-center px-4`}>
                    <div className="flex flex-col items-center justify-center text-center">
                        <div className="flex h-8 w-8 items-center justify-center rounded-full border border-red-100 bg-red-50 text-red-500">
                            <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                                <path d="M12 8v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M12 16h.01" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                            </svg>
                        </div>
                        <div className="mt-3">
                            <p className="text-xs font-medium text-gray-800">{title}</p>
                            <p className="mt-0.5 text-xs text-gray-400">{description}</p>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
}